import { all, takeEvery, takeLatest } from 'redux-saga/effects';
import { getAddressSaga } from './address';
import { AddressTypes } from './address/addressTypes';
import {
  AddressByBodyshopTypes,
  getAddressByBodyshopSaga
} from './addressByBodyshop';
import {
  AddressTypeTypes,
  getAddressTypePublicSaga,
  getAddressTypeSaga
} from './addressType';
import { AffectedTypeTypes } from './affectedType';
import { getAffectedTypeSaga } from './affectedType/affectedTypeSaga';
import { RateImportStatusTypes, getRateImportStatusSaga } from './rateImportStatus';
import {
  AnnouncementTypes,
  getDomainAnnouncementsSaga,
  getDomainCompanyAnnouncersSaga,
  getDomainWhoCanSeeSaga,
  getStatusDomainSaga
} from './announcement';
import { AssessmentTypeTypes, getAssessmentTypeSaga } from './assessmentType';
import { BillingAddressTypes, getBillingAddressSaga } from './billingAddress';
import { BodyshopTypes, getBodyshopsSaga } from './bodyshop';
import { BodyshopBranchTypes, getBodyshopBranchesSaga } from './bodyshopBranch';
import { BodyshopTypeTypes, getBodyshopTypeSaga } from './bodyshopType';
import { BrandTypes, getBrandSaga } from './brand';
import {
  CartTypes,
  addCartSaga,
  clearAllCartSaga,
  loadCartSaga,
  removeCartSaga,
  updateCartSaga
} from './cart';
import {
  CartCountStatusTypes,
  getCartCountStatusSaga
} from './cartCountStatus';
import { CartStatusTypes, getCartStatusSaga } from './cartStatus';
import { CategoryTypes, getCategorySaga } from './category';
import {
  ClaimFileCategoryTypes,
  getClaimFileCategorySaga
} from './claimFileCategory';
import { ClaimTypeTypes, getClaimTypeSaga } from './claimType';
import { CompanyTypes, getCompanyAllSaga, getCompanySaga } from './company';
import { CompanyBranchTypes, getCompanyBranchSaga } from './companyBranch';
import {
  CompanyManufacturerTypes,
  getCompanyManufacturerSaga
} from './companyManufacturer';
import {
  CompanyTypeTypes,
  getCompanyTypePublicSaga,
  getCompanyTypeSaga
} from './companyType';
import { ContactTypeTypes, getContactTypeSaga } from './contactType';
import { ControlTypes, getControlsByScreenSaga } from './control';
import {
  CountryTypes,
  getCountriesPublicSaga,
  getCountriesUserSaga
} from './country';
import { CultureTypes, getCultureSaga } from './culture';
import { DamageAreaTypes, getDamageAreasSaga } from './damageArea';
import { DamageCategoryTypes, getDamageCategoriesSaga } from './damageCategory';
import { DeliveryTypeTypes, getDeliveryTypesSaga } from './deliveryType';
import {
  DistributionRegionTypes,
  getDistributionRegionSaga
} from './distributionRegion';
import { EntityTypeTypes, getEntityTypeSaga } from './entityType';
import {
  ExcludeVariablesTypes,
  getExcludeVariablesSaga
} from './excludeVariables';
import {
  InsuranceSublineTypes,
  getInsuranceSublinesSaga
} from './insuranceSubline';
import {
  InsurerTypes,
  getInsurersFullSaga,
  getInsurersPublicSaga,
  getInsurersSaga,
  getUsersByInsurerSaga
} from './insurer';
import {
  IntegrationQueueStatusTypes,
  getIntegrationQueueStatusSaga
} from './integrationQueueStatus';
import {
  IntegrationTriggerTypes,
  getIntegrationTriggerSaga
} from './integrationTrigger';
import {
  IntegrationTypes,
  getDomainIntegrationIntegrationInterfacesSaga,
  getDomainSaga,
  getIntegrationIntegrationInterfaceSaga,
  getIntegrationInterfaceSaga,
  getServiceSaga
} from './integrationType';
import {
  ManagePackagesCountStatusTypes,
  getManagePackagesCountStatusSaga
} from './managePackagesCountStatus';
import { MappingTypeTypes, getMappingTypeSaga } from './mappingType';
import { MenuTypes, getMenuSaga } from './menu';
import { MunicipalityTypes, getMunicipalitySaga } from './municipality';
import { PackageTypes, getPackageSaga } from './package';
import { ParameterTypes, getParametersByTypeAndCompanySaga, getParametersSaga } from './parameter';
import { ParameterByTypeScreenTypes } from './parameterByTypeScreen';
import { getParameterByTypeScreenSaga } from './parameterByTypeScreen/parameterByTypeScreenSagas';
import {
  PartTypeTypes,
  getPartTypeSaga,
  getPartTypesByDirectAssignCriteriaSaga,
  getPartTypesBySupplierAndVehicleManufacturerSaga
} from './partType';
import {
  PositionTypes,
  getPositionSaga,
  getPositionWithIdPIESSaga
} from './position';
import {
  PredefinedSearchTypes,
  getPredefinedSearchSaga
} from './predefinedSearch';
import { PreQuoteTypeTypes, getPreQuoteTypeSaga } from './preQuoteType';
import {
  QuoteCountStatusTypes,
  getQuoteCountStatusSaga
} from './quoteCountStatus';
import { getQuoteImportStatusSaga } from './quoteImportStatus/quoteImportStatusSagas';
import { QuoteImportStatusTypes } from './quoteImportStatus/quoteImportStatusTypes';
import {
  QuoteStatusTypes,
  getQuoteStatusDomainSaga,
  getQuoteStatusSaga
} from './quoteStatus';
import { ReasonTypes, getReasonSaga } from './reason';
import {
  ReportScheduleStatusTypes,
  getReportScheduleStatusSaga
} from './reportScheduleStatus';
import {
  ReportTemplateTypes,
  getReportTemplateDomainSaga
} from './reportTemplate';
import {
  ReportTemplateTypeTypes,
  getReportTemplateTypeSaga
} from './reportTemplateType';
import { GET_PAYLOAD_FORMAT, fetchPayloadFormat } from './RequestFormat';
import { SchedulerUsersTypes, getSchedulerUsersSaga } from './schedulerUsers';
import {
  StateTypes,
  getStatesByBodyshopSaga,
  getStatesUserSaga
} from './state';
import { StatusRegisterTypes, getStatusRegisterSaga } from './statusRegister';
import { SubcategoryTypes, getSubcategorySaga } from './subcategory';
import { SummaryTypes, getSummarySaga } from './summary';
import {
  SupervisorTypes,
  getSupervisorsDomainSaga,
  getSupervisorsSaga
} from './supervisor';
import { SupplierTypes, getSuppliersSaga } from './supplier';
import {
  SupplierInventoryImportStatusTypes,
  getSupplierInventoryImportStatusSaga
} from './supplierInventoryImportStatus';
import {
  SupplierInventoryWarehouseStatusTypes,
  getSupplierInventoryWarehouseStatusSaga
} from './supplierInventoryWarehouseStatus';
import { SupplierTypeTypes, getSupplierTypeSaga } from './supplierType';
import { SupplierCategoryTypes, getSupplierCategorySaga } from './supplierCategory';
import {
  SystemApplicationTypes,
  getSystemApplicationSaga
} from './systemApplication';
import {
  TemplateEmailNotificationTypes,
  getDomainBySystemApplicationSaga
} from './templateEmailNotification';
import { TimeZoneTypes, getTimeZonesUserSaga } from './timeZone';
import { UserTypes, getUserPreferenceSaga, userSignInSaga } from './user';
import { UserGroupTypes, getUsersGroupUserSaga } from './userGroup';
import { UserTypeTypes, getUserTypeSaga } from './userType';
import { ValuatorTypes, getValuatorsSaga } from './valuator';
import {
  ManufacturerTypes,
  getManufacturersSaga
} from './vehicle/manufacturer';
import { ModelTypes, getModelsSaga } from './vehicle/model';
import { SubModelTypes, getSubModelsSaga } from './vehicle/subModel';
import {
  YearTypes,
  getYearByManufacturerAndModelSaga,
  getYearsSaga
} from './vehicle/year';
import { VisualIdentityTypes, getVisualIdentitySaga } from './visualIdentity';
import { WarehouseTypes, getWarehouseSaga } from './warehouse';
import {
  DomainUsersByCompanyTypes,
  getDomainUsersByCompanySaga
} from '@/main/store/domainUsersByCompany';
import { getTireBrandSaga, PartBrandTypes } from '@/main/store/partBrand';
import { FileTypeTypes, getFileTypeSaga } from '@/main/store/fileType';
import { ApprovalMatrixTypeTypes, getApprovalMatrixTypeSaga } from '@/main/store/approvalMatrixType';
import { getUserHierarchySaga, UserHierarchyTypes } from '@/main/store/userHierarchy';

export default function* RootSaga(): Generator {
  return yield all([
    takeLatest(UserTypes.USER_SIGNIN, userSignInSaga),
    takeLatest(CountryTypes.GET_COUNTRIES_USER, getCountriesUserSaga),
    takeLatest(CountryTypes.GET_COUNTRIES_PUBLIC, getCountriesPublicSaga),
    takeLatest(StatusRegisterTypes.GET_STATUS_REGISTER, getStatusRegisterSaga),
    takeLatest(CompanyTypeTypes.GET_COMPANY_TYPE, getCompanyTypeSaga),
    takeLatest(
      CompanyTypeTypes.GET_COMPANY_TYPE_PUBLIC,
      getCompanyTypePublicSaga
    ),
    takeLatest(CompanyTypes.GET_COMPANY, getCompanySaga),
    takeLatest(CompanyBranchTypes.GET_COMPANY_BRANCH, getCompanyBranchSaga),
    takeLatest(CultureTypes.GET_CULTURE, getCultureSaga),
    takeLatest(TimeZoneTypes.GET_TIMEZONES_USER, getTimeZonesUserSaga),
    takeLatest(UserGroupTypes.GET_USERSGROUP_USER, getUsersGroupUserSaga),
    takeLatest(BodyshopTypes.GET_BODYSHOPS, getBodyshopsSaga),
    takeLatest(
      BodyshopBranchTypes.GET_BODYSHOP_BRANCHES,
      getBodyshopBranchesSaga
    ),
    takeLatest(InsurerTypes.GET_INSURERS, getInsurersSaga),
    takeLatest(InsurerTypes.GET_INSURERS_PUBLIC, getInsurersPublicSaga),
    takeLatest(InsurerTypes.GET_INSURERS_FULL, getInsurersFullSaga),
    takeLatest(
      InsuranceSublineTypes.GET_INSURANCE_SUBLINES,
      getInsuranceSublinesSaga
    ),
    takeLatest(SupplierTypes.GET_SUPPLIERS, getSuppliersSaga),
    takeLatest(StateTypes.GET_STATES_USER, getStatesUserSaga),
    takeLatest(StateTypes.GET_STATES_BY_BODYSHOP, getStatesByBodyshopSaga),
    takeLatest(MenuTypes.GET_MENU, getMenuSaga),
    takeLatest(ContactTypeTypes.GET_CONTACT_TYPE, getContactTypeSaga),
    takeLatest(MunicipalityTypes.GET_MUNICIPALITY, getMunicipalitySaga),
    takeLatest(AddressTypeTypes.GET_ADDRESS_TYPE, getAddressTypeSaga),
    takeLatest(
      AddressTypeTypes.GET_ADDRESS_TYPE_PUBLIC,
      getAddressTypePublicSaga
    ),
    takeLatest(SupplierTypeTypes.GET_SUPPLIER_TYPE, getSupplierTypeSaga),
    takeLatest(SupplierCategoryTypes.GET_SUPPLIER_CATEGORY, getSupplierCategorySaga),
    takeLatest(YearTypes.GET_YEARS, getYearsSaga),
    takeLatest(
      YearTypes.GET_YEARS_BY_MANUFACTURER_AND_MODEL,
      getYearByManufacturerAndModelSaga
    ),
    takeLatest(ManufacturerTypes.GET_MANUFACTURERS, getManufacturersSaga),
    takeLatest(ModelTypes.GET_MODELS, getModelsSaga),
    takeLatest(SubModelTypes.GET_SUBMODELS, getSubModelsSaga),
    takeLatest(DamageAreaTypes.GET_DAMAGEAREAS, getDamageAreasSaga),
    takeLatest(
      AddressByBodyshopTypes.GET_ADDRESSBYBODYSHOP,
      getAddressByBodyshopSaga
    ),
    takeLatest(CartTypes.LOAD_CART, loadCartSaga),
    takeEvery(CartTypes.ADDING_CART, addCartSaga),
    takeLatest(CartTypes.UPDATING_CART, updateCartSaga),
    takeEvery(CartTypes.REMOVING_CART, removeCartSaga),
    takeLatest(CartTypes.CLEAR_ALL_CART, clearAllCartSaga),
    takeLatest(PartTypeTypes.GET_PART_TYPE, getPartTypeSaga),
    takeLatest(
      PartTypeTypes.GET_PART_TYPES_BY_SUPPLIER_MANUFACTURER,
      getPartTypesBySupplierAndVehicleManufacturerSaga
    ),
    takeLatest(ControlTypes.GET_CONTROLS_BY_SCREEN, getControlsByScreenSaga),
    takeLatest(CategoryTypes.GET_CATEGORY, getCategorySaga),
    takeLatest(QuoteStatusTypes.GET_QUOTE_STATUS, getQuoteStatusSaga),
    takeLatest(
      QuoteStatusTypes.GET_DOMAIN_QUOTE_STATUS,
      getQuoteStatusDomainSaga
    ),
    takeLatest(ClaimTypeTypes.GET_CLAIM_TYPE, getClaimTypeSaga),
    takeLatest(ReasonTypes.GET_REASON, getReasonSaga),
    takeLatest(
      DistributionRegionTypes.GET_DISTRIBUTION_REGION,
      getDistributionRegionSaga
    ),
    takeLatest(
      QuoteCountStatusTypes.GET_QUOTE_COUNT_STATUS,
      getQuoteCountStatusSaga
    ),
    takeLatest(UserTypes.GET_USER_PREFERENCES, getUserPreferenceSaga),
    takeLatest(SummaryTypes.GET_SUMMARY, getSummarySaga),
    takeLatest(CartStatusTypes.GET_CART_STATUS, getCartStatusSaga),
    takeLatest(
      CartCountStatusTypes.GET_CART_COUNT_STATUS,
      getCartCountStatusSaga
    ),
    takeLatest(BillingAddressTypes.GET_BILLING_ADDRESS, getBillingAddressSaga),
    takeLatest(WarehouseTypes.GET_WAREHOUSE, getWarehouseSaga),
    takeLatest(BrandTypes.GET_BRAND, getBrandSaga),
    takeLatest(PackageTypes.GET_PACKAGE, getPackageSaga),
    takeLatest(
      SupplierInventoryImportStatusTypes.GET_SUPPLIER_INVENTORY_IMPORT_STATUS,
      getSupplierInventoryImportStatusSaga
    ),
    takeLatest(
      SupplierInventoryWarehouseStatusTypes.GET_SUPPLIER_INVENTORY_WAREHOUSE_STATUS,
      getSupplierInventoryWarehouseStatusSaga
    ),
    takeLatest(SubcategoryTypes.GET_SUBCATEGORY, getSubcategorySaga),
    takeLatest(PositionTypes.GET_POSITION, getPositionSaga),
    takeLatest(PositionTypes.GET_POSITION_IDPIES, getPositionWithIdPIESSaga),
    takeLatest(InsurerTypes.GET_INSURERS_FULL, getInsurersFullSaga),
    takeLatest(
      InsurerTypes.GET_INSURERS_USERS_BY_INSURER,
      getUsersByInsurerSaga
    ),
    takeLatest(
      QuoteImportStatusTypes.GET_QUOTE_IMPORT_STATUS,
      getQuoteImportStatusSaga
    ),
    takeLatest(
      IntegrationTypes.GET_INTEGRATION_INTEGRATION_INTERFACE,
      getIntegrationIntegrationInterfaceSaga
    ),
    takeLatest(
      IntegrationTriggerTypes.GET_INTEGRATION_TRIGGER,
      getIntegrationTriggerSaga
    ),
    takeLatest(IntegrationTypes.GET_DOMAIN, getDomainSaga),
    takeLatest(
      IntegrationQueueStatusTypes.GET_INTEGRATION_QUEUE_STATUS,
      getIntegrationQueueStatusSaga
    ),
    takeLatest(
      IntegrationTypes.GET_DOMAIN_INTEGRATION_INTEGRATION_INTERFACES,
      getDomainIntegrationIntegrationInterfacesSaga
    ),
    takeLatest(
      IntegrationTypes.GET_INTEGRATION_INTERFACE,
      getIntegrationInterfaceSaga
    ),
    takeLatest(IntegrationTypes.GET_SERVICE, getServiceSaga),
    takeLatest(MappingTypeTypes.GET_MAPPING_TYPE, getMappingTypeSaga),
    takeLatest(AssessmentTypeTypes.GET_ASSESSMENT_TYPE, getAssessmentTypeSaga),
    takeLatest(
      ManagePackagesCountStatusTypes.GET_MANAGEPACKAGES_COUNT_STATUS,
      getManagePackagesCountStatusSaga
    ),
    takeEvery(
      ParameterByTypeScreenTypes.GET_PARAMETER_BY_TYPE,
      getParameterByTypeScreenSaga
    ),
    takeLatest(AddressTypes.GET_ADDRESS, getAddressSaga),
    takeLatest(
      ReportScheduleStatusTypes.GET_REPORT_SCHEDULE_STATUS,
      getReportScheduleStatusSaga
    ),
    takeLatest(SchedulerUsersTypes.GET_SCHEDULER_USERS, getSchedulerUsersSaga),
    takeLatest(UserTypeTypes.GET_USER_TYPE, getUserTypeSaga),
    takeLatest(AddressTypes.GET_ADDRESS, getAddressSaga),
    takeLatest(DeliveryTypeTypes.GET_DELIVERYTYPES, getDeliveryTypesSaga),
    takeLatest(CompanyTypes.GET_COMPANY_ALL, getCompanyAllSaga),
    takeLatest(PreQuoteTypeTypes.GET_PRE_QUOTE_TYPE, getPreQuoteTypeSaga),
    takeLatest(
      SystemApplicationTypes.GET_SYSTEM_APPLICATION,
      getSystemApplicationSaga
    ),
    takeLatest(ValuatorTypes.GET_VALUATORS, getValuatorsSaga),
    takeLatest(SupervisorTypes.GET_SUPERVISOR_DOMAIN, getSupervisorsDomainSaga),
    takeLatest(SupervisorTypes.GET_SUPERVISOR, getSupervisorsSaga),
    takeLatest(ParameterTypes.GET_PARAMETERS, getParametersSaga),
    takeLatest(
      DamageCategoryTypes.GET_DAMAGE_CATEGORIES,
      getDamageCategoriesSaga
    ),
    takeLatest(BodyshopTypeTypes.GET_BODYSHOP_TYPE, getBodyshopTypeSaga),
    takeLatest(EntityTypeTypes.GET_ENTITY_TYPE, getEntityTypeSaga),
    takeLatest(
      CompanyManufacturerTypes.GET_COMPANY_MANUFACTURER,
      getCompanyManufacturerSaga
    ),
    takeLatest(AffectedTypeTypes.GET_AFFECTED_TYPE, getAffectedTypeSaga),
    takeLatest(RateImportStatusTypes.GET_RATE_IMPORT_STATUS, getRateImportStatusSaga),
    takeLatest(GET_PAYLOAD_FORMAT, fetchPayloadFormat),
    takeLatest(
      ReportTemplateTypes.GET_REPORT_TEMPLATE_DOMAIN,
      getReportTemplateDomainSaga
    ),
    takeLatest(
      ReportTemplateTypeTypes.GET_REPORT_TEMPLATE_TYPE,
      getReportTemplateTypeSaga
    ),
    takeLatest(
      ClaimFileCategoryTypes.GET_CLAIM_FILE_CATEGORY,
      getClaimFileCategorySaga
    ),
    takeLatest(
      ExcludeVariablesTypes.GET_EXCLUDE_VARIABLES,
      getExcludeVariablesSaga
    ),
    takeLatest(VisualIdentityTypes.GET_VISUAL_IDENTITY, getVisualIdentitySaga),
    takeLatest(
      TemplateEmailNotificationTypes.GET_DOMAIN_BY_SYSTEM_APPLICATION,
      getDomainBySystemApplicationSaga
    ),
    takeLatest(
      AnnouncementTypes.GET_DOMAIN_ANNOUNCEMENTS,
      getDomainAnnouncementsSaga
    ),
    takeLatest(AnnouncementTypes.GET_STATUS_DOMAIN, getStatusDomainSaga),
    takeLatest(
      AnnouncementTypes.GET_DOMAIN_COMPANY_ANNOUNCERS,
      getDomainCompanyAnnouncersSaga
    ),
    takeLatest(
      AnnouncementTypes.GET_DOMAIN_WHO_CAN_SEE,
      getDomainWhoCanSeeSaga
    ),
    takeLatest(
      PredefinedSearchTypes.GET_DOMAIN_PREDEFINED_SEARCH,
      getPredefinedSearchSaga
    ),
    takeLatest(
      PartTypeTypes.GET_PART_TYPES_BY_DIRECT_ASSIGN_CRITERIA,
      getPartTypesByDirectAssignCriteriaSaga
    ),
    takeLatest(
      DomainUsersByCompanyTypes.GET_DOMAIN_USERS_BY_COMPANY,
      getDomainUsersByCompanySaga
    ),
    takeLatest(PartBrandTypes.GET_TIRE_BRAND, getTireBrandSaga),
      takeLatest(FileTypeTypes.GET_FILE_TYPE, getFileTypeSaga),
    takeLatest(ParameterTypes.GET_PARAMETER_BY_TYPE_AND_COMPANY, getParametersByTypeAndCompanySaga),
    takeLatest(ApprovalMatrixTypeTypes.GET_APPROVAL_MATRIX_TYPE, getApprovalMatrixTypeSaga),
    takeLatest(UserHierarchyTypes.GET_USER_HIERARCHY, getUserHierarchySaga)
  ]);
}
